export default "__VITE_ASSET__DYLhMUcC__"